import { Reducer } from "redux";

import { GetReferralListActionDispatchTypes } from "../constants/HomePage";
import { ReferralDetailsResponse } from "../models/api/Referral";
import { ReferralListDispatchTypes } from "../models/dispatchTypes/Referral";

export const defaultReferralInfo = {
  referralId: 0,
  authorizationNumber: "",
  referralStatusName: "",
  minEffectiveFromDate: "",
  maxEffectiveThroughDate: "",
  sn: 0,
  pt: 0,
  ot: 0,
  st: 0,
  msw: 0,
  hha: 0,
  lastName: "",
  firstName: "",
  dateOfBirth: "",
  gender: "",
  medicareBeneficiaryIdentifier: "",
  patientId: 0,
  totalRows: 0,
  authorizationTypeName: "",
  subscriberId: "",
  reimbursementTypeId: 0,
  reimbursementTypeName: "",
  benefitPlan: "",
};

const initialState: ReferralDetailsResponse = {
  loading: false,
  response: [defaultReferralInfo],
  error: null,
};

const ReferralListReducer: Reducer<
  ReferralDetailsResponse,
  ReferralListDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case GetReferralListActionDispatchTypes.GET_REFERRAL_LIST_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case GetReferralListActionDispatchTypes.GET_REFERRAL_LIST_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case GetReferralListActionDispatchTypes.GET_REFERRAL_LIST_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case GetReferralListActionDispatchTypes.GET_REFERRAL_LIST_RESET: {
      return initialState;
    }
  }
  return state;
};

export default ReferralListReducer;
